module.exports = __webpack_public_path__ + "media/images/home/feature/management_csv-1d9303feadff2f99dac2a0971fd76e0b.png";